import { createApp } from "vue";
import "./style.css";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import NativeButton from "./components/NativeUI/NativeButton.vue";
import NativeCol from "./components/NativeUI/NativeCol.vue";
import NativeDrawer from "./components/NativeUI/NativeDrawer.vue";
import NativeForm from "./components/NativeUI/NativeForm.vue";
import NativeFormItem from "./components/NativeUI/NativeFormItem.vue";
import NativeInput from "./components/NativeUI/NativeInput.vue";
import NativeInputNumber from "./components/NativeUI/NativeInputNumber.vue";
import NativeOption from "./components/NativeUI/NativeOption.vue";
import NativeRow from "./components/NativeUI/NativeRow.vue";
import NativeSelect from "./components/NativeUI/NativeSelect.vue";
import NativeSkeleton from "./components/NativeUI/NativeSkeleton.vue";
import NativeSwitch from "./components/NativeUI/NativeSwitch.vue";

const pinia = createPinia();

const app = createApp(App);
app.component("NativeButton", NativeButton);
app.component("NativeCol", NativeCol);
app.component("NativeDrawer", NativeDrawer);
app.component("NativeForm", NativeForm);
app.component("NativeFormItem", NativeFormItem);
app.component("NativeInput", NativeInput);
app.component("NativeInputNumber", NativeInputNumber);
app.component("NativeOption", NativeOption);
app.component("NativeRow", NativeRow);
app.component("NativeSelect", NativeSelect);
app.component("NativeSkeleton", NativeSkeleton);
app.component("NativeSwitch", NativeSwitch);
app.use(pinia).use(router).mount("#app");
